import { lazyLoad } from 'utils/loadable';

export const FooterPlayer = lazyLoad(
  () => import('./index'),
  module => module.FooterPlayer,
);
